import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import BasicDetails from "../../Components/BasicDetails/BasicDetails";
import DashboardRightSection from "../../Components/DashboardRightSection/DashboardRightSection";
import EditCoverPhoto from "../../Components/EditCoverPhoto/EditCoverPhoto";
import EditName from "../../Components/EditName/EditName";
import WithdrawRequest from "../../Components/WithdrawRequest/WithdrawRequest";
import EditDOB from "../../Components/EditDOB/EditDOB";
import EditAddress from "../../Components/EditAddress/EditAddress";
import EditLanguage from "../../Components/EditLanguage/EditLanguage";
import EditGender from "../../Components/EditGender/EditGender";
import EditPoliticalAffiliation from "../../Components/EditPoliticalAffiliation/EditPoliticalAffiliation";
import EditProfessions from "../../Components/EditProfessions/EditProfessions";
import "./ProfileDetailsPage.css";

const ProfileDetailsPage = ({ activeProfileDetailsComponent }) => {
    const navigate = useNavigate();

    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        {activeProfileDetailsComponent !== "basicDetails" && (
                            <div className="profileDetailsHeaderBar">
                                <button
                                    className="profileDetailsBackBtn"
                                    onClick={() => navigate("/profile-details")}
                                >
                                    <ArrowBackRoundedIcon sx={{ fontSize: 18 }} />
                                    <span>Back</span>
                                </button>
                            </div>
                        )}
                        {activeProfileDetailsComponent === "basicDetails" && <BasicDetails />}
                        {activeProfileDetailsComponent === "editCoverPhoto" && <EditCoverPhoto />}
                        {activeProfileDetailsComponent === "editName" && <EditName />}
                        {activeProfileDetailsComponent === "withdrawRequest" && <WithdrawRequest />}
                        {activeProfileDetailsComponent === "editDOB" && <EditDOB />}
                        {activeProfileDetailsComponent === "editAddress" && <EditAddress />}
                        {activeProfileDetailsComponent === "editLanguage" && <EditLanguage />}
                        {activeProfileDetailsComponent === "editGender" && <EditGender />}
                        {activeProfileDetailsComponent === "editPoliticalAffiliation" && <EditPoliticalAffiliation />}
                        {activeProfileDetailsComponent === "editProfessions" && <EditProfessions />}
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileDetailsPage;